"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrimdinesCurseAbilityHandler = exports.GrimdinesCurseActorAbilityFactory = exports.GrimdinesCurseAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/event-handlers/core");
class GrimdinesCurseAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.GrimdinesCurse;
        this.__typeName = "GrimdinesCurse";
    }
}
exports.GrimdinesCurseAbilityArgs = GrimdinesCurseAbilityArgs;
let GrimdinesCurseActorAbilityFactory = class GrimdinesCurseActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("GrimdinesCurse", "Self", 0);
    }
};
GrimdinesCurseActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("GrimdinesCurse")
], GrimdinesCurseActorAbilityFactory);
exports.GrimdinesCurseActorAbilityFactory = GrimdinesCurseActorAbilityFactory;
let GrimdinesCurseAbilityHandler = class GrimdinesCurseAbilityHandler {
    init(sequence, container, actorId) {
        const enemies = container.selectLivingTargets(actorId, Target_1.Target.AllEnemies);
        const effectIds = enemies.map((enemyId) => container.applyDebuff({
            sequence,
            attackerId: actorId,
            targetId: enemyId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PercentHealingDecrease, 10),
            supernatural: true,
        }));
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEffectsEffectArgs([
                new core_1.LinkedEventHandlerEffectArgs("Grimdine's Curse", "Decreases enemy max health by 2% on turn start", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, "Ability_GrimdinesCurse_OnTurnStarted", {})),
                new core_1.LinkedEventHandlerEffectArgs("Grimdine's Curse", "Reduces enemy healing received by 10%", false, container.registerEventHandler(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_2.CancelEffectsEventHandlerArgs(effectIds)))
            ], false)
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
GrimdinesCurseAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.GrimdinesCurse)
], GrimdinesCurseAbilityHandler);
exports.GrimdinesCurseAbilityHandler = GrimdinesCurseAbilityHandler;
